import * as React from 'react';
import './popups.scss';
import { Badge, Button } from 'components';
import { Table } from 'components/table/table';
import { Link, useNavigate } from 'react-router-dom';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import { TableColumn } from 'react-data-table-component';
import { message, Popover, Tag, Tooltip } from 'antd';
import { getPageNum } from '../../../../core/utils/paggingHelper';
import { PopUp } from '../../../../core/domain/popups/popups';
import { PaginationList } from '../../../../core/domain';
import { Card } from '../../../../components/card/card';
import { buttonType } from '../../../../components/button/button';
import { DeletePopupModal } from './delete-modal/delete-modal';
import { getAllPopUps } from '../../../../core/repositories/popups';
import { Page } from '../../../../components/page/page';

export const PopUps: React.FC = () => {
    const [cardLoading, setCardLoading] = React.useState<boolean>(false);
    const [popups, setPopups] = React.useState<PaginationList<PopUp>>();
    const [pageSize, setPageSize] = React.useState<number>(10);
    const [selectedPopup, setSelectedPopup] = React.useState<PopUp>();
    const [deleteModalOpen, setDeleteModalOpen] = React.useState<boolean>(false);

    const navigate = useNavigate();

    React.useEffect(() => {
        !popups && getAllPopUps(setCardLoading, setPopups, getPageNum(), pageSize, '');
    }, []);

    const handleDeleteClick = (item: PopUp) => {
        setSelectedPopup(item);
        setDeleteModalOpen(true);
    };

    const onDeleteComplete = () => {
        getAllPopUps(setCardLoading, setPopups, getPageNum(), pageSize, '');
        message.success('پاپ‌آپ با موفقیت حذف شد');
        setDeleteModalOpen(false);
        setSelectedPopup(undefined);
    };

    const columns: TableColumn<PopUp>[] = [
        {
            name: 'عنوان',
            id: 'title',
            selector: (row) => row?.title,
        },
        {
            name: 'توضیحات',
            id: 'description',
            selector: (row) => row.description || '',
            cell: (record) => (
                <Popover content={record.description}>
                    <span className="description-column">{record.description}</span>
                </Popover>
            ),
        },
        {
            name: 'تعداد نمایش',
            id: 'viewCount',
            selector: (row) => row.viewCount,
        },
        {
            name: 'فاصله بین هر نمایش',
            id: 'intervalView',
            selector: (row) => row.intervalView,
        },
        {
            name: 'نمایش بعد از (ثانیه)',
            id: 'viewAfterSecond',
            selector: (row) => row.viewAfterSecond,
        },
        {
            name: 'نمایش برای سطح',
            id: 'forLevelUniqueName',
            selector: (row) => row.forLevelUniqname.map((i) => i.title).join(','),
            cell: (record) => (
                <div className="levels-column">
                    {record?.forLevelUniqname?.map((i) => (
                        <Tag color="blue">
                            {i.id == 1
                                ? 'سطح پایه'
                                : i.id == 2
                                  ? 'سطح 1'
                                  : i.id == 3
                                    ? 'سطح 2'
                                    : i.id == 4
                                      ? 'سطح 3'
                                      : i.id == 5
                                        ? 'سطح 4'
                                        : ''}
                        </Tag>
                    ))}
                </div>
            ),
            // با اضافه شدن ستون پلتفرم، جمع عرض‌ها از عرض جدول بیشتر می‌شد و عملیات زیر اسکرول می‌رفت
            width: '20%',
        },
        {
            name: 'پلتفرم',
            id: 'platform',
            selector: (row) => row.platform?.title ?? 'همه پلتفرم ها',
            cell: (record) =>
                record.platform ? (
                    <Tag color="purple">{record.platform.title}</Tag>
                ) : (
                    <Tag>همه پلتفرم ها</Tag>
                ),
        },
        {
            name: 'وضعیت',
            id: 'isActive',
            width: '10%',
            selector: (row) => row?.isActive,
            cell: (record) => (
                <Badge text={record.isActive ? 'فعال' : 'غیر فعال'} type={record.isActive ? 'success' : 'error'} />
            ),
        },
        {
            name: 'عملیات',
            id: 'actions',
            cell: (record) => (
                <div className="actions">
                    <Tooltip placement="top" title="اصلاح پاپ‌آپ">
                        <Link to={`edit/${record.id}`}>
                            <EditOutlined />
                        </Link>
                    </Tooltip>
                    <Tooltip placement={'top'} title={'حذف پاپ‌آپ'}>
                        <DeleteOutlined onClick={() => handleDeleteClick(record)} />
                    </Tooltip>
                </div>
            ),
        },
    ];

    return (
        <Page title={'مدیریت پاپ‌آپ ها'} className={'pmx-popups'}>
            <Card title="پاپ‌آپ ها" blur={cardLoading}>
                <DeletePopupModal
                    isOpen={deleteModalOpen}
                    setIsOpen={setDeleteModalOpen}
                    popUp={selectedPopup!}
                    onComplete={onDeleteComplete}
                />
                <div className="row">
                    <Button
                        type={buttonType.info}
                        text="افزودن پاپ آپ"
                        icon={<PlusOutlined />}
                        onClick={() => navigate('add')}
                    />
                </div>
                {popups && (
                    <Table
                        className="popup-popups-table"
                        data={popups?.items}
                        column={columns}
                        pagination={popups?.pagination}
                        getdata={getAllPopUps}
                        setdata={setPopups}
                        setloader={setCardLoading}
                        setloading={setCardLoading}
                        setPageSize={setPageSize}
                    />
                )}
            </Card>
        </Page>
    );
};
